"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nextState = exports.MID = exports.DATA = exports.PHASE = exports.ERROR_MSG = exports.ST = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _drivers = _interopRequireDefault(require("./drivers"));

/**
 * State machine valid states
 */
var ST = {
  START: 'START',
  // [ST.EMAIL_ENTERED],
  EMAIL_ENTERED: 'EMAIL_ENTERED',
  // [ST.TENANT_SELECT],
  LOGIN_INFO_FETCH: 'LOGIN_INFO_FETCH',
  LOGIN_INFO_FAIL: 'LOGIN_INFO_FAIL',
  TENANT_FETCH: 'TENANT_FETCH',
  TENANT_SELECT: 'TENANT_SELECT',
  // [ST.CONFIG_COMPLETE, ST.NO_TENANT_FOUND],
  CONFIG_COMPLETE: 'CONFIG_COMPLETE',
  // [ST.LOGIN, ST.TENANT_SELECT],
  LOGIN_REDIRECT: 'LOGIN_REDIRECT',
  LOGIN: 'LOGIN',
  // [ST.FAIL],
  NO_TENANT_FOUND: 'NO_TENANT_FOUND',
  // [ST.START],
  FAIL: 'FAIL',
  // [ST.CONFIG_COMPLETE]
  PASSWORD_ENTERED: 'PASSWORD_ENTERED',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD'
};
exports.ST = ST;
var ERROR_MSG = 'ERROR_MSG';
exports.ERROR_MSG = ERROR_MSG;
var PHASE = 'PHASE';
exports.PHASE = PHASE;
var DATA = 'DATA';
exports.DATA = DATA;
var MID = 'MID';
/**
 * Gets the mid-core for the state machine
 *
 * @param {Map} st - current state
 * @return {MidCore} - the mid-core instance
 */

exports.MID = MID;

var midCore = function midCore(st) {
  return st.get(MID);
};
/**
 * Gets the login widget
 *
 * @param {Map} st - current state
 * @return {LoginWidget} - the login widget
 */


var loginWidget = function loginWidget(st) {
  return st.get(MID).loginWidget;
};
/**
 * Checks the login info for completeness
 * @param {LoginInfo} loginInfo - the login info from the solution endpoint
 * @return {Array} - a list of errors; empty if no errors found
 */


var checkLoginInfo = function checkLoginInfo(loginInfo) {
  var errors = [];

  if (!loginInfo.appId) {
    errors.push('loginInfo missing application Id');
  }

  if (!loginInfo.oidcConfigUrl) {
    errors.push('loginInfo missing OIDC Configuration URL');
  }

  if (!loginInfo.authDriver) {
    errors.push('loginInfo missing authentication driver');
  }

  return errors;
};
/**
 * Check a tenant object for errors
 *
 * @param {Tenant} tenant - the tenant to check for errors
 * @return {Array} an array of errors, empty if no errors found
 */


var checkTenant = function checkTenant(tenant) {
  var errors = [];

  if (!tenant.tenantId) {
    errors.push('Missing tenant Id');
  }

  if (!tenant.domain) {
    errors.push('Missing domain');
  }

  if (!tenant.appId) {
    errors.push('Missing app Id');
  }

  if (!tenant.audience) {
    errors.push('Missing audience');
  }

  if (!tenant.oidcConfigUrl) {
    errors.push('Missing OIDC Configuration URL');
  }

  if (!tenant.authDriver) {
    errors.push('Missing authentication driver');
  }

  return errors;
};
/**
 * Check all tenants for errors.
 *
 * @param {Array<Tenant>} tenants - the list of tenants returned by the tenantSelect call
 * @return {Array<string>} if there are any errors, they will be here
 */


var checkTenants = function checkTenants(tenants) {
  var errors = []; // if tenants isn't iterable or it's simply missing, return an error

  if (!tenants || !tenants.forEach) {
    errors.push('No valid tenants provided');
  } else {
    tenants.forEach(function (tenant) {
      return errors.concat(checkTenant(tenant));
    });
  }

  return errors;
};
/**
 * Proceed to the next state given a current state.
 * @param {Map} current McKinsey ID state
 * @param {Map} next the next state to transition to
 * @return {Promise<Map<string, any>>} a promise that resolves once the state transitions are done
 */


var proceed = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(current, next) {
    var errors, phase, email, loginInfo, loginInfoErrors, _next$get, accessToken, idToken, _loginInfo, mid, driver, _email, tenants, tenantSelectErrors, _mid, tenant;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(next === null)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", next);

          case 2:
            errors = midCore(next).errors;
            _context.prev = 3;

            if (!(current.get(PHASE) === next.get(PHASE))) {
              _context.next = 9;
              break;
            }

            phase = next.get(PHASE);

            if (!(phase !== ST.FAIL)) {
              _context.next = 9;
              break;
            }

            console.error('mid-sdk entered an infinite loop on phase: ', phase);
            return _context.abrupt("return", next.set(PHASE, ST.FAIL).set(ERROR_MSG, errors.ERR_UNHANDLED('Internal login failure')));

          case 9:
            _context.t0 = next.get(PHASE);
            _context.next = _context.t0 === ST.EMAIL_ENTERED ? 12 : _context.t0 === ST.TENANT_FETCH ? 60 : _context.t0 === ST.TENANT_SELECT ? 110 : _context.t0 === ST.LOGIN_INFO_FAIL ? 110 : _context.t0 === ST.NO_TENANT_FOUND ? 110 : _context.t0 === ST.FAIL ? 110 : _context.t0 === ST.PASSWORD_ENTERED ? 110 : _context.t0 === ST.CONFIG_COMPLETE ? 110 : _context.t0 === ST.FORGOT_PASSWORD ? 110 : _context.t0 === ST.LOGIN_REDIRECT ? 118 : _context.t0 === ST.LOGIN ? 119 : 124;
            break;

          case 12:
            email = next.get(DATA);

            if (email) {
              _context.next = 24;
              break;
            }

            _context.t1 = proceed;
            _context.t2 = next;
            _context.next = 18;
            return loginWidget(next).transition(next.set(PHASE, ST.START));

          case 18:
            _context.t3 = _context.sent;
            _context.next = 21;
            return (0, _context.t1)(_context.t2, _context.t3);

          case 21:
            return _context.abrupt("return", _context.sent);

          case 24:
            // defend against external emailToLoginInfo being bad

            /** {LoginInfo} **/
            loginInfo = {};
            _context.prev = 25;
            _context.next = 28;
            return midCore(next).emailToLoginInfo(email);

          case 28:
            loginInfo = _context.sent;
            loginInfoErrors = checkLoginInfo(loginInfo);

            if (!(loginInfoErrors.length > 0)) {
              _context.next = 39;
              break;
            }

            _context.t4 = proceed;
            _context.t5 = next;
            _context.next = 35;
            return loginWidget(next).transition(next.set(PHASE, ST.LOGIN_INFO_FAIL).set(ERROR_MSG, errors.FAIL_CONN_LOGIN_INFO(loginInfoErrors.join(', '))));

          case 35:
            _context.t6 = _context.sent;
            _context.next = 38;
            return (0, _context.t4)(_context.t5, _context.t6);

          case 38:
            return _context.abrupt("return", _context.sent);

          case 39:
            _context.next = 52;
            break;

          case 41:
            _context.prev = 41;
            _context.t7 = _context["catch"](25);
            console.error('emailToLoginInfo threw an exception:', _context.t7);
            _context.t8 = proceed;
            _context.t9 = next;
            _context.next = 48;
            return loginWidget(next).transition(next.set(PHASE, ST.LOGIN_INFO_FAIL).set(ERROR_MSG, errors.FAIL_CONN_LOGIN_INFO()));

          case 48:
            _context.t10 = _context.sent;
            _context.next = 51;
            return (0, _context.t8)(_context.t9, _context.t10);

          case 51:
            return _context.abrupt("return", _context.sent);

          case 52:
            _context.t11 = proceed;
            _context.t12 = next;
            _context.next = 56;
            return loginWidget(next).transition(next.set(PHASE, ST.CONFIG_COMPLETE).set(DATA, loginInfo));

          case 56:
            _context.t13 = _context.sent;
            _context.next = 59;
            return (0, _context.t11)(_context.t12, _context.t13);

          case 59:
            return _context.abrupt("return", _context.sent);

          case 60:
            _next$get = next.get(DATA), accessToken = _next$get.accessToken, idToken = _next$get.idToken, _loginInfo = _next$get.loginInfo;

            if (!(!accessToken || !idToken || !_loginInfo)) {
              _context.next = 70;
              break;
            }

            _context.t14 = proceed;
            _context.t15 = next;
            _context.next = 66;
            return loginWidget(next).transition(next.set(PHASE, ST.FAIL).set(ERROR_MSG, errors.FAIL_BAD_TOKENS('Bad Tokens')));

          case 66:
            _context.t16 = _context.sent;
            _context.next = 69;
            return (0, _context.t14)(_context.t15, _context.t16);

          case 69:
            return _context.abrupt("return", _context.sent);

          case 70:
            _context.prev = 70;
            mid = midCore(next);
            driver = (0, _drivers["default"])(mid, _loginInfo);
            _context.next = 75;
            return driver.email(mid, _loginInfo);

          case 75:
            _email = _context.sent;
            _context.next = 78;
            return mid.tenantListing(_email, accessToken);

          case 78:
            tenants = _context.sent;
            tenantSelectErrors = checkTenants(tenants.endpoints);

            if (!(tenantSelectErrors.length > 0)) {
              _context.next = 89;
              break;
            }

            _context.t17 = proceed;
            _context.t18 = next;
            _context.next = 85;
            return loginWidget(next).transition(next.set(PHASE, ST.LOGIN_INFO_FAIL).set(ERROR_MSG, errors.FAIL_CONN_TENANT_SELECT(tenantSelectErrors.join(','))));

          case 85:
            _context.t19 = _context.sent;
            _context.next = 88;
            return (0, _context.t17)(_context.t18, _context.t19);

          case 88:
            return _context.abrupt("return", _context.sent);

          case 89:
            _context.t20 = proceed;
            _context.t21 = next;
            _context.next = 93;
            return loginWidget(next).transition(next.set(PHASE, ST.TENANT_SELECT).set(DATA, tenants));

          case 93:
            _context.t22 = _context.sent;
            _context.next = 96;
            return (0, _context.t20)(_context.t21, _context.t22);

          case 96:
            return _context.abrupt("return", _context.sent);

          case 99:
            _context.prev = 99;
            _context.t23 = _context["catch"](70);
            console.error('tenantListing threw an exception:', _context.t23);
            _context.t24 = proceed;
            _context.t25 = next;
            _context.next = 106;
            return loginWidget(next).transition(next.set(PHASE, ST.LOGIN_INFO_FAIL).set(ERROR_MSG, errors.FAIL_CONN_TENANT_SELECT()));

          case 106:
            _context.t26 = _context.sent;
            _context.next = 109;
            return (0, _context.t24)(_context.t25, _context.t26);

          case 109:
            return _context.abrupt("return", _context.sent);

          case 110:
            _context.t27 = proceed;
            _context.t28 = next;
            _context.next = 114;
            return loginWidget(next).transition(next);

          case 114:
            _context.t29 = _context.sent;
            _context.next = 117;
            return (0, _context.t27)(_context.t28, _context.t29);

          case 117:
            return _context.abrupt("return", _context.sent);

          case 118:
            return _context.abrupt("return", next);

          case 119:
            _mid = midCore(next);
            tenant = next.get(DATA);

            _mid.setTenant(tenant);

            _mid.onComplete(); // this is a terminal state


            return _context.abrupt("return", next);

          case 124:
            return _context.abrupt("return", next);

          case 127:
            _context.prev = 127;
            _context.t30 = _context["catch"](3);
            console.error("uncaught exception ".concat(_context.t30.name, " during state transition"), _context.t30);
            return _context.abrupt("return", next.set(PHASE, ST.FAIL).set(ERROR_MSG, errors.ERR_UNHANDLED('Unknown error')));

          case 131:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 127], [25, 41], [70, 99]]);
  }));

  return function proceed(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Move the state machine to the next state by merging the updated properties in `next` to
 * `current`
 *
 * @param {Promise<Map>|Map} current - the current mid instance
 * @param {Map} next - the changes to apply to `current` to obtain the next state
 * @return {Promise<Map>} - a promise that resolves when the state machine transitions
 */


var nextState = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(current, next) {
    var c;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return current;

          case 2:
            c = _context2.sent;
            return _context2.abrupt("return", proceed(c, c.merge(next)));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function nextState(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

exports.nextState = nextState;